export default __webpack_public_path__ + "static/media/birta_ceiling.20364df2.png";